import React from 'react'
import {BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import FirstMileController from "./pages/controllers/first_mile_controllers";
function App() {
  return (
      <>
        <Router>
          <Routes>
            <Route path={'/first-mile'} element={<FirstMileController/>}></Route>
          </Routes>
        </Router>
        <ToastContainer />
      </>
  );
}

export default App;
